module.exports = __webpack_public_path__ + "static/sustainDemo-71734c95e3a9378d3d24a6e91646fce2.mp4";